import * as React from 'react'
import { Box, Button, Popover, Tooltip, Typography, styled, useTheme } from '@mui/material'
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClockRotateLeft, faXmark } from '@fortawesome/free-solid-svg-icons'
import CategoryIcons from './CategoryIcons.js'
import AttachMenu from './AttachMenu.jsx'
import { cardHeaderSx, truncateText } from './constants.js'

const BootstrapDialog = styled(Popover)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0,0,0,0.2)',
  },
  '& .MuiPaper-root': {
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
    border: '1px solid #d7dbe3',
  },
}))

export default function HistoryDialogs(props) {
  const { historyTemplated, anchorEl, open, onClose, attachmentOpt } = props
  const status = (historyTemplated.Status || '').toLowerCase()
  const [selAttach, setSelAttach] = React.useState({})
  const theme = useTheme()
  React.useEffect(() => {
    if (historyTemplated?.AlowAttachment == 1 && attachmentOpt.length > 0) {
      setSelAttach(attachmentOpt.filter((val) => val?.AttachmentTag == historyTemplated?.AttachmentTag)?.[0] || {})
    }
  }, [historyTemplated, attachmentOpt])

  const statusColor = !status ? '#7a7f87' : status === 'approved' ? '#3bc66b' : status === 'rejected' ? '#ff4e4d' : '#d0ad1d'
  const statusBg = !status ? 'transparent' : status === 'approved' ? '#e9f8ee' : status === 'rejected' ? '#ffe9ea' : '#fdf7df'
  const statusText = !status ? '' : `Earlier Template Submission Status`

  return (
    <BootstrapDialog
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      BackdropProps={{ invisible: false, sx: { backgroundColor: 'rgba(0,0,0,0.2)' } }}
      PaperProps={{
        style: {
          width: 360,
          maxWidth: 'calc(100vw - 24px)',
          zIndex: 999,
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', background: '#fff' }}>
        <Box sx={{ ...cardHeaderSx, background: theme.palette.primary.main, minHeight: 48, px: 1.5 }}>
          <RadioButtonUncheckedRoundedIcon sx={{ fontSize: 20, color: 'rgba(255,255,255,0.9)', flexShrink: 0 }} />
          <Tooltip title={historyTemplated.Header || ''} placement="top" arrow>
            <Typography sx={{ ...truncateText, fontWeight: 700, color: '#fff', fontSize: '15px', flex: 1 }}>
              {historyTemplated.Header || ''}
            </Typography>
          </Tooltip>
          <CategoryIcons Category={historyTemplated?.Category} />
          <Tooltip title={'history'} placement="top">
            <FontAwesomeIcon icon={faClockRotateLeft} size="lg" className="HistoryIcons" />
          </Tooltip>
          {historyTemplated?.AlowAttachment === 1 ? (
            historyTemplated?.HasAttachment == 1 ? (
              <AttachMenu
                label={<AttachFileIcon sx={{ margin: 0, color: '#fff', fontSize: '20px', transform: 'rotate(45deg)' }} />}
                options={attachmentOpt.filter((val) => val?.AttachmentTag == historyTemplated?.AttachmentTag)}
                selectedValue={selAttach}
                onselect={() => {}}
                idKey="AttachmentTag"
                dataKey="AttachmentName"
              />
            ) : (
              <AttachFileIcon sx={{ margin: 0, color: '#fff', transform: 'rotate(45deg)' }} />
            )
          ) : null}
        </Box>

        <Box sx={{ bgcolor: statusBg, borderBottom: statusText ? '1px solid #e3e6eb' : 0 }}>
          <Typography variant="body2" sx={{ px: 1.5, py: 1, color: statusColor, fontSize: '13px' }}>
            {statusText}
          </Typography>
        </Box>

        <Box
          sx={{
            px: 1.5,
            py: 1.25,
            minHeight: 140,
            maxHeight: 220,
            overflowY: 'auto',
            fontSize: '14px',
            fontWeight: 500,
            color: '#333741',
            lineHeight: 1.45,
            whiteSpace: 'pre-wrap',
            '&::-webkit-scrollbar': { width: 6 },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#999', borderRadius: 2 },
          }}
        >
          {historyTemplated?.MavenMessage || ''}
        </Box>

        <Box
          sx={{
            borderTop: '1px solid #d6dbe3',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            px: 1.5,
            py: 1.1,
          }}
        >
          {status === 'rejected' ? (
            <Tooltip
              title={historyTemplated?.StatusMessage || ''}
              placement="top-start"
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: '#ff4e4d',
                    color: 'white',
                  },
                },
              }}
            >
              <Typography variant="body2" sx={{ textTransform: 'capitalize', color: statusColor, fontSize: '13px', fontWeight: 600 }}>
                {`${status}${historyTemplated?.StatusUpdateDate ? ` On ${historyTemplated.StatusUpdateDate}` : ''}`}
              </Typography>
            </Tooltip>
          ) : (
            <Typography variant="body2" sx={{ textTransform: 'capitalize', color: statusColor, fontSize: '13px', fontWeight: 600 }}>
              {status ? `${status}${historyTemplated?.StatusUpdateDate ? ` On ${historyTemplated.StatusUpdateDate}` : ''}` : ''}
            </Typography>
          )}
          <Button
            sx={{
              color: 'var(--base-color)',
              textTransform: 'capitalize',
              minWidth: 'auto',
              padding: 0,
              fontSize: '13px',
              fontWeight: 500,
            }}
            onClick={onClose}
          >
            <FontAwesomeIcon icon={faXmark} style={{ marginRight: '4px' }} />
            Close
          </Button>
        </Box>
      </Box>
    </BootstrapDialog>
  )
}
